// extracted by mini-css-extract-plugin
export var bubble = "_3l-0";
export var container = "_3l-3";
export var contrastBorder = "_3l-4";
export var greyOut = "_3l-2";
export var initialsWrapper = "_3l-1";
export var large = "_3l-9";
export var medium = "_3l-8";
export var mediumSmall = "_3l-7";
export var mediumSmallMedium = "_3l-c";
export var micro = "_3l-5";
export var small = "_3l-6";
export var tiny = "_3l-b";
export var xTiny = "_3l-a";